import ContentLoader from "react-content-loader";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";
import { merge } from "react-merge";

const styles = {
    mobile: {
        wrapper: {
            margin: "0 4.83vw"
        },
        card: {
            border: "2px solid" + Color.LoaderBackground,
            borderRadius: "2.41vw",
            width: "100%",
            height: "38.75vw",
            backgroundColor: Color.White
        }
    },
    desktop: {
        wrapper: {
            margin: "2vw 0 0 8.83vw"
        },
        card: {
            width: "59.2vw",
            borderRadius: "0.52vw",
            height: "7.11vw"
        }
    }
};

export const ActivePromotionsLoader: React.FC = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    var loaderStyles = styles.mobile;

    if (!isMobile) {
        let extendStyles = merge(styles.mobile, styles.desktop);
        loaderStyles = extendStyles;
    }

    return (
        <div style={loaderStyles.wrapper}>
            <div style={loaderStyles.card}>
                <ContentLoader
                    speed={1}
                    width={"100%"}
                    height={loaderStyles.card.height}
                    backgroundColor={Color.LoaderBackground}
                    foregroundColor={Color.LoaderForeground}
                >
                    {isMobile ? <>
                        <rect x="4.34%" y="7%" rx="5" ry="5" width="37.65%" height="13%"/>
                        <circle cx="10.36%" cy="41.80%" r="8.52%" />
                        <rect x="34.43%" y="32.45%" rx="5" ry="5" width="58.12%" height="16.87%"/>
                        <rect x="4.34%" y="71.24%" rx="5" ry="5" width="24.32%" height="12.39%"/>
                        <rect x="34.43%" y="67.24%" rx="5" ry="5" width="32.32%" height="10.39%"/>
                        <rect x="34.43%" y="81.24%" rx="5" ry="5" width="57.98%" height="10.39%"/>
                    </> 
                    : <>
                        <rect x="1.75%" y="7.51%" rx="5" ry="5" width="19.97%" height="20.23%"/>
                        <circle cx="6.36%" cy="61.80%" r="3.52%" />
                        <rect x="14.55%" y="55.67%" rx="5" ry="5" width="27.77%" height="19.49%"/>
                        <rect x="48.55%" y="59.67%" rx="5" ry="5" width="10.77%" height="14.49%"/>
                        <rect x="64.55%" y="55.67%" rx="5" ry="5" width="27.77%" height="19.49%"/>
                    </>}                     
                </ContentLoader>
            </div>
        </div>
    );
}